<template>
  <section class="container section pt-3">
    <div class="title is-4">{{ $t("product homologation") }}</div>
    <div class="columns">
      <div class="column">
        <div class="title is-5 has-text-centered">
          <p>{{ $t("modul products") }}</p>
        </div>
        <div
          class="py-1"
          v-for="element in modul_product_list.filter((i) => !i.homologated)"
        >
          <div class="tag has-addons px-0 mr-3">
            <span
              class="button tag"
              :data-tooltip="$t('export')"
              @click="export_to_woocommerce(element)"
            >
              <span class="icon">
                <i class="fa fa-upload"></i>
              </span>
            </span>
            <span
              class="tag px-5"
              :class="{
                'is-primary': element == selected_modul_product,
              }"
              >{{ element.name }}</span
            >
            <span
              class="button tag"
              v-if="!element.homologated"
              :data-tooltip="$t('homologate with woocommerce product')"
              @click="pair('product', element, 'modul')"
            >
              <span class="icon">
                <i class="fa fa-angle-right"></i>
              </span>
            </span>
            <span
              class="button tag"
              v-if="element.homologated"
              @click="unpair(element, 'modul')"
              :data-tooltip="$t('remove homologation')"
            >
              <span class="icon has-text-danger">
                <i class="fa fa-close"></i>
              </span>
            </span>
            <span class="tag" v-if="element.homologated">{{
              element.homologated.name
            }}</span>
          </div>
        </div>
        <!-- <pre>{{ modul_product_list }}</pre> -->
      </div>
      <div class="column">
        <div class="title is-5 has-text-centered">
          {{ $t("woocommerce products") }}
        </div>
        <div
          class="py-1"
          v-for="element in woocommerce_product_list.filter(
            (i) => !i.homologated
          )"
        >
          <div v-if="element.type == 'variable'">
            <div class="tag has-addons px-0 mr-3">
              <span class="tag">
                <span class="icon has-text-primary">
                  <i class="fa fa-plus"></i>
                </span>
              </span>
              <span class="tag px-5">{{ element.name }}</span>
            </div>
            <div class="content">
              <ul class="mt-1">
                <li
                  style="list-style-type: none"
                  v-for="variation in element.variations.filter((v) => {
                    return !homologated_variations.find(
                      (hv) =>
                        hv.product_id == element.product_id &&
                        hv.variation_id == v.id
                    );
                  })"
                  :key="variation.product_id"
                >
                  <div class="tag has-addons px-0 mr-3">
                    <span
                      class="button tag"
                      :data-tooltip="$t('homologate with modul product')"
                      @click="
                        pair('variation', variation, 'woocommerce', element)
                      "
                    >
                      <span class="icon">
                        <i class="fa fa-angle-left"></i>
                      </span>
                    </span>
                    <span
                      class="tag px-5"
                      :class="{
                        'is-info': variation == selected_woocommerce_variation,
                      }"
                      >{{ variation.name }}</span
                    >
                    <span
                      class="button tag"
                      :data-tooltip="$t('import')"
                      @click="import_to_modul(element, variation)"
                    >
                      <span class="icon">
                        <i class="fa fa-download"></i>
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-else>
            <div class="tag has-addons px-0 mr-3">
              <span class="tag" v-if="element.homologated">{{
                element.homologated.name
              }}</span>
              <span
                class="button tag"
                v-if="element.homologated"
                @click="unpair(element, 'woocommerce')"
                :data-tooltip="$t('remove homologation')"
              >
                <span class="icon has-text-danger">
                  <i class="fa fa-close"></i>
                </span>
              </span>
              <span
                class="button tag"
                v-if="!element.homologated"
                :data-tooltip="$t('homologate with modul product')"
                @click="pair('product', element, 'woocommerce')"
              >
                <span class="icon">
                  <i class="fa fa-angle-left"></i>
                </span>
              </span>
              <span
                class="tag px-5"
                :class="{
                  'is-info': element == selected_woocommerce_product,
                }"
                >{{ element.name }}</span
              >
              <span
                class="button tag"
                :data-tooltip="$t('import')"
                @click="import_to_modul(element)"
              >
                <span class="icon">
                  <i class="fa fa-download"></i>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- <pre>{{ woocommerce_product_list }}</pre> -->
      </div>
      <div class="column">
        <div class="title is-5 has-text-centered">
          {{ $t("homologated products") }}
        </div>
        <div class="py-1" v-for="element in homologated_products">
          <div class="tag has-addons px-0 mr-3">
            <span class="tag is-primary">{{ element.name }}</span>
            <span
              class="tag is-hoverable"
              @click="unpair(element, 'modul')"
              :data-tooltip="$t('remove homologation')"
            >
              <span class="icon has-text-danger">
                <i class="fa fa-close"></i>
              </span>
            </span>
            <span
              class="tag is-info"
              v-if="element.homologated.type == 'product'"
              >{{ element.homologated.name }}</span
            >
            <div
              v-else-if="element.homologated.type == 'variation'"
              class="tag has-addons px-0 mr-0"
            >
              <span class="tag is-info">{{ element.homologated.name }}</span>
              <span class="tag"
                ><span class="icon"> <i class="fa fa-angle-right"></i> </span
              ></span>
              <span class="tag is-dark">{{
                element.homologated.variation.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  warning_message,
  error_message,
  get,
  put,
  del,
  confirm_deletion_dialog,
} from "@/utils";

export default {
  name: "WoocommerceHomologation",
  components: {},
  data() {
    return {
      is_loading: false,
      selected_modul_product: null,
      selected_woocommerce_product: null,
      selected_woocommerce_variation: null,
      modul_product_list: [],
      woocommerce_product_list: [],
    };
  },
  computed: {
    homologated_products() {
      return this.modul_product_list.filter((e) => e.homologated);
    },
    homologated_variations() {
      let v = this;
      let homologated = v.modul_product_list
        .filter((e) => e.homologated)
        .filter((e) => e.homologated.type === "variation");
      let list = homologated.reduce((prev, curr) => {
        prev.push({
          product_id: curr.homologated.product_id,
          variation_id: curr.homologated.variation.id,
        });
        return prev;
      }, []);
      return list;
    },
  },
  methods: {
    refresh() {
      let v = this;
      get("/woocommerce/homologation/products", {})
        .then((response) => {
          // console.log("response", response);
          v.modul_product_list = response.modul_products.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          v.woocommerce_product_list = response.woocommerce_products.sort(
            (a, b) => a.name.localeCompare(b.name)
          );
          let homologations = response.homologations;
          homologations.forEach((h) => {
            v.modul_product_list = v.modul_product_list.map((e) => {
              if (e.product_id === h.modul_product_id) {
                let trgt = v.woocommerce_product_list.find(
                  (p) => p.product_id === h.woocommerce_product_id
                );
                let variation = null;
                if (h.type === "variation") {
                  variation = trgt.variations.find(
                    (v) => v.id === h.variation_id
                  );
                }
                e.homologated = {
                  name: trgt.name,
                  product_id: h.woocommerce_product_id,
                  homologation_id: h.homologation_id,
                  type: h.type,
                  variation: variation,
                };
              }
              return e;
            });
            v.woocommerce_product_list = v.woocommerce_product_list.map((e) => {
              if (
                e.product_id === h.woocommerce_product_id &&
                h.type !== "variation"
              ) {
                let trgt = v.modul_product_list.find(
                  (p) => p.product_id === h.modul_product_id
                );
                e.homologated = {
                  name: trgt.name,
                  product_id: h.modul_product_id,
                  homologation_id: h.homologation_id,
                };
              }
              return e;
            });
          });
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        });
    },
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    pair(type, target, source, element) {
      let v = this;
      if (type === "product") {
        element = target;
        if (source === "modul") {
          v.selected_modul_product = element;
          if (v.selected_woocommerce_product)
            v.homologate(
              v.selected_modul_product,
              v.selected_woocommerce_product
            );
          else if (v.selected_woocommerce_variation)
            v.homologate_variation(
              v.selected_modul_product,
              v.selected_woocommerce_variation,
              {
                product_id:
                  v.selected_woocommerce_variation.woocommerce_product_id,
                name: v.selected_woocommerce_variation.woocommerce_product_name,
              }
            );
        } else {
          v.selected_woocommerce_variation = null;
          v.selected_woocommerce_product = element;
          if (v.selected_modul_product) {
            v.homologate(
              v.selected_modul_product,
              v.selected_woocommerce_product
            );
          }
        }
      } else if (type === "variation") {
        target.woocommerce_product_id = element.product_id;
        target.woocommerce_product_name = element.name;
        v.selected_woocommerce_variation = target;
        v.selected_woocommerce_product = null;
        if (v.selected_modul_product) {
          v.homologate_variation(
            v.selected_modul_product,
            v.selected_woocommerce_variation,
            element
          );
        }
      }
    },
    homologate(modul_product, woocommerce_product) {
      let v = this;
      put("/woocommerce/homologation", {
        modul_product_id: modul_product.product_id,
        woocommerce_product_id: woocommerce_product.product_id,
      })
        .then((response) => {
          v.modul_product_list = v.modul_product_list.map((e) => {
            if (e.product_id === modul_product.product_id)
              e.homologated = {
                name: woocommerce_product.name,
                product_id: woocommerce_product.product_id,
                homologation_id: response.homologation_id,
                type: "product",
              };
            else if (
              e.homologated &&
              e.homologated.product_id === woocommerce_product.product_id
            )
              delete e.homologated;
            return e;
          });
          v.woocommerce_product_list = v.woocommerce_product_list.map((e) => {
            if (e.product_id === woocommerce_product.product_id)
              e.homologated = {
                name: modul_product.name,
                product_id: modul_product.product_id,
                homologation_id: response.homologation_id,
                type: "product",
              };
            else if (
              e.homologated &&
              e.homologated.product_id === modul_product.product_id
            )
              delete e.homologated;
            return e;
          });
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        })
        .finally(() => {
          setTimeout(() => {
            v.selected_modul_product = null;
            v.selected_woocommerce_product = null;
            v.selected_woocommerce_variation = null;
            // v.draw();
          }, 50);
        });
      // console.log("homologate", modul_product, woocommerce_product);
    },
    homologate_variation(
      modul_product,
      woocommerce_variation,
      woocommerce_product
    ) {
      let v = this;
      put("/woocommerce/homologation/variation", {
        modul_product_id: modul_product.product_id,
        woocommerce_product_id: woocommerce_product.product_id,
        woocommerce_variation_id: woocommerce_variation.id,
      })
        .then((response) => {
          v.modul_product_list = v.modul_product_list.map((e) => {
            if (e.product_id === modul_product.product_id)
              e.homologated = {
                name: woocommerce_product.name,
                product_id: woocommerce_product.product_id,
                homologation_id: response.homologation_id,
                type: "variation",
                variation: {
                  name: woocommerce_variation.name,
                  id: woocommerce_variation.id,
                },
              };
            else if (
              e.homologated &&
              e.homologated.product_id === woocommerce_variation.product_id
            )
              delete e.homologated;
            return e;
          });
          v.woocommerce_product_list = v.woocommerce_product_list.map((e) => {
            if (e.product_id === woocommerce_variation.product_id)
              e.homologated = {
                name: modul_product.name,
                product_id: modul_product.product_id,
                homologation_id: response.homologation_id,
              };
            else if (
              e.homologated &&
              e.homologated.product_id === modul_product.product_id
            )
              delete e.homologated;
            return e;
          });
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        })
        .finally(() => {
          setTimeout(() => {
            v.selected_modul_product = null;
            v.selected_woocommerce_product = null;
            v.selected_woocommerce_variation = null;
            // v.draw();
          }, 50);
        });
      // console.log("homologate", modul_product, woocommerce_product);
    },
    unpair(element, source) {
      let v = this;
      if (source === "modul") {
        del("/woocommerce/homologation", {
          id: element.product_id,
          source: "modul",
        })
          .then(() => {
            v.modul_product_list = v.modul_product_list.map((e) => {
              if (e.product_id === element.product_id) delete e.homologated;
              return e;
            });
            v.woocommerce_product_list = v.woocommerce_product_list.map((e) => {
              if (
                e.homologated &&
                e.homologated.product_id === element.product_id
              )
                delete e.homologated;
              return e;
            });
          })
          .catch((err) => {
            console.error(err);
            error_message(err);
          });
      } else {
        del("/woocommerce/homologation", {
          id: element.product_id,
          source: "woocommerce",
        })
          .then(() => {
            v.woocommerce_product_list = v.woocommerce_product_list.map((e) => {
              if (e.product_id === element.product_id) delete e.homologated;
              return e;
            });
            v.modul_product_list = v.modul_product_list.map((e) => {
              if (
                e.homologated &&
                e.homologated.product_id === element.product_id
              )
                delete e.homologated;
              return e;
            });
          })
          .catch((err) => {
            console.error(err);
            error_message(err);
          });
      }
    },
    export_to_woocommerce(element) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to export product to woocommerce?"),
        v,
        () => {
          v.$root.loader(true);
          put("/woocommerce/homologation/export", {
            product_id: element.product_id,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              console.error(error);
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
    import_to_modul(element, variation) {
      let v = this;
      confirm_deletion_dialog(
        v.$t(
          "are you sure to import product from woocommerce to modul product catalog?"
        ),
        v,
        () => {
          v.$root.loader(true);
          put("/woocommerce/homologation/import", {
            product_id: element.product_id,
            variation_id: variation ? variation.id : null,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              console.error(error);
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
  created() {},
};
</script>

<style scoped></style>
